<template>
  <div class="dynamic__detail-container">
    <Dynamic v-if="dynamic" :dynamics="dynamic" isDetail></Dynamic>
  </div>
</template>

<script>
import Dynamic from '@/pages/dynamic/_list.vue';

export default {
  components: {
    Dynamic,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dynamic: undefined,
    };
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  updated() {
    console.log(this.id, 'detail updated');
  },
  methods: {
    async init() {
      try {
        this.$store.commit('openLoading');
        const res = await this.getDetail();
        this.dynamic = [res.data];
      } catch (err) {
        console.log(err);
      }
      this.$store.commit('closeLoading');
    },
    getDetail() {
      return this.$http.post('html/Dynamic/dynamicDetail', {
        id: this.id,
      });
    },
  },
};
</script>

<style></style>
